module.exports = __webpack_public_path__ + "img/sell_through_rate.7dbd100c.svg";